import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseControl, ObservacioneExpediente, TextArea } from '@app/shared';

@Injectable()
export class ObservationProcessFormService {
  constructor() { }

  /**
   * Retorna el formulario de observaciones
   *
   * @param {ObservacioneExpediente} [observation]
   * @returns {BaseControl<any>[]}
   * @memberof ObservationProcessFormService
   */
  getFields(observation?: ObservacioneExpediente): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new TextArea({
          key: 'txtObservacion',
          label: 'Observacion:',
          rows: '5',
          notResize: false,
          value: observation ? observation.observacion : null,
          order: 1,
          placeholder: 'Ingrese una descripción',
          validations: {
            validators: [
                Validators.required
            ],
            messages: {
              required: 'Debe ingresar una observación'
            }
          }
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/flow/observation-process/shared/observation-process.form.service.ts